import { MouseEvent, useCallback } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getCurrentUserId, selectPreferredLanguage } from "features/authSlice";
import { useGetFeatureFlagsQuery } from "services/common/featureFlagService";
import { useGetBorrowerDetailsQuery } from "pages/dashboard/home/dashboardService";
import { resolveLanguageForMyLoansLanding } from "utilities/getPreferredLanguage";
import { enterMyLoansWithLangPref } from "utilities/langPrefCookie";

const isModifiedClick = (event?: MouseEvent<HTMLElement>): boolean => {
  if (!event) {
    return false;
  }

  return event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0;
};

export const useEnterMyLoansWithLangPref = (): ((event?: MouseEvent<HTMLElement>) => void) => {
  const navigate = useNavigate();
  const userId = useSelector(getCurrentUserId);
  const reduxLanguage = useSelector(selectPreferredLanguage);
  const { data: featureFlag } = useGetFeatureFlagsQuery();
  const { data: userProfile } = useGetBorrowerDetailsQuery(userId, {
    skip: !userId,
  });

  return useCallback(
    (event?: MouseEvent<HTMLElement>) => {
      if (isModifiedClick(event)) {
        return;
      }

      event?.preventDefault();

      const language = resolveLanguageForMyLoansLanding(userProfile?.preferredLanguage, reduxLanguage);
      enterMyLoansWithLangPref({
        language,
        isPreferredLanguageEnabled: Boolean(featureFlag?.preferredLanguageEnabled),
        spaNavigate: () => {
          navigate("/my-loans", {
            replace: true,
            state: { previousPath: globalThis.location.pathname },
          });
        },
      }).catch(() => undefined);
    },
    [featureFlag?.preferredLanguageEnabled, navigate, reduxLanguage, userProfile?.preferredLanguage],
  );
};
